/*function customOpenTab(tabId) {
  document.querySelectorAll('.custom-tab-content').forEach(c => { c.classList.remove('active'); c.style.display='none'; });
  document.querySelectorAll('.custom-tabs li').forEach(h => h.classList.remove('active'));
  const activeContent = document.getElementById(tabId);
  if (activeContent) { activeContent.style.display='block'; activeContent.classList.add('active'); }
  const header = document.querySelector(`.custom-tabs li[data-tab=\"${tabId}\"]`);
  if (header) header.classList.add('active');
}
document.addEventListener('DOMContentLoaded', () => {
  const first = document.querySelector('.custom-tabs li');
  if (first) customOpenTab(first.dataset.tab);
});*/

function customOpenTab(tabId) {
  document.querySelectorAll('.custom-tab-content').forEach(c => {
    c.classList.remove('active');
    c.style.display = 'none';
  });

  document.querySelectorAll('.custom-tabs li').forEach(h => {
    h.classList.remove('active');
  });

  document
    .querySelectorAll(`.custom-tab-content[id="${tabId}"]`)
    .forEach(c => {
      c.style.display = 'block';
      c.classList.add('active');
    });

  document
    .querySelectorAll(`.custom-tabs li[data-tab="${tabId}"]`)
    .forEach(h => {
      h.classList.add('active');
    });
}

document.addEventListener('DOMContentLoaded', () => {
  const first = document.querySelector('.custom-tabs li');
  if (first) customOpenTab(first.dataset.tab);
});